import { render, staticRenderFns } from "./NotificationsCenter.vue?vue&type=template&id=2cc350e6&scoped=true"
import script from "./NotificationsCenter.vue?vue&type=script&lang=js"
export * from "./NotificationsCenter.vue?vue&type=script&lang=js"
import style1 from "./NotificationsCenter.vue?vue&type=style&index=1&id=2cc350e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc350e6",
  null
  
)

export default component.exports